export default {
  fields: {
    online_shop_domain: 'Eigen domein voor de webshop',
    online_shop_domain_hint:
      'Een domein van het restaurant, zoals order.pizzeria-mario.com — alleen voor bestellingen; een website heeft een ander domein nodig. Na het opslaan staan hier de records die moeten worden toegevoegd.',
    online_shop_domain_placeholder: 'order.pizzeria-mario.com',
  },
};
